import CryptoJS from 'crypto-js';

// 默认密钥（建议从环境变量中获取，不要硬编码）
const CRYPTOJSKEY = '60afL1G1b39c5Z27';

function encrypt(plaintText) {
	var plaintText = plaintText;
	var options = {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	};
  // console.log(plaintText,options);
	var key = CryptoJS.enc.Utf8.parse(CRYPTOJSKEY);
	var encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
	var encryptedBase64Str = encryptedData.toString().replace(/\//g, "_");
	encryptedBase64Str = encryptedBase64Str.replace(/\+/g, "-");
	return encryptedBase64Str;
}

//解密
function decrypt(encryptedBase64Str) {
	if (encryptedBase64Str.slice(0, 1) == '"') {
		encryptedBase64Str = encryptedBase64Str.substring(1, encryptedBase64Str.length - 1)

	}

	var vals = encryptedBase64Str.replace(/\-/g, '+').replace(/_/g, '/');
	var options = {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	};
	var key = CryptoJS.enc.Utf8.parse(CRYPTOJSKEY);
	var decryptedData = CryptoJS.AES.decrypt(vals, key, options);
	var decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData);
	return decryptedStr
}

export {
	encrypt,
	decrypt
}